import { useEffect, useRef } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

const videoSrc = '/media/power-stream/teaser/pc';
const { EFPic } = createEFPic(`${videoSrc}/`);

export default function MultiScene() {
    const { t } = useLang('powerstream.detail.sectionD');
    const boxRef = useRef<HTMLDivElement>();
    const data = [
        { num: t('sec2.saved.costsNum'), text: t('sec2.saved.costsText') },
        { num: t('sec2.saved.betterNum'), text: t('sec2.saved.betterText') },
        { num: t('sec2.saved.wasteNum'), text: t('sec2.saved.wasteText') },
    ];

    useEffect(() => {
        const boxDom: any = boxRef.current;
        const pageHeight = document.documentElement.clientHeight;
        if (pageHeight < 850) {
            const scale = document.documentElement.clientHeight / 1000;
            (boxDom as HTMLDivElement).style.cssText = `transform:scale(${scale});`;
        }
        AniContainer.create({
            triggerElement: '.scene-section',
            asyncFromTo: [
                ['.scene-section .wasted .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -80 }, 0.4],
                ['.scene-section .night', { opacity: 0 }, { opacity: 1 }, 0.4],
                ['.scene-section .night .text-box', { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, 0.4],
                ['.scene-section .night .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -80 }, 0.4],
                ['.scene-section .cuts', { opacity: 0 }, { opacity: 1 }, 0.4],
                ['.scene-section .cuts .text-box', { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, 0.4],
                ['.scene-section .cuts .cuts-img', { opacity: 1 }, { opacity: 0 }, 0.6],
            ],
            asyncTimeLine: [0, 0.3, 0.3, 1, 1.3, 1.3, 1.7],
            triggerHook: 0,
            offset: '10%',
            duration: '280%',
        });
    }, []);

    return (
        <div className={styles.multiScene}>
            <div className="scene-section">
                <div className="scene-sticky" ref={boxRef}>
                    <div className="scene-common wasted">
                        <div className="scene-text">
                            <div className="text-box">
                                <p className="scene-title">{t('sec2.saved.title')}</p>
                                <p className="scene-desc">
                                    {t.rich('sec2.saved.desc', {
                                        HighLight: (text: any) => <span className="green-text">{text}</span>,
                                        sup: (val: any) => <sup>{val}</sup>,
                                    })}
                                </p>
                            </div>
                            <div className="scene-video">
                                <div className="video-box">
                                    <EFVideo
                                        className="bg-video ani-03"
                                        autoPlay={true}
                                        loop={true}
                                        muted
                                        sources={[`${videoSrc}/3.webm`, `${videoSrc}/3.mp4`]}
                                    />
                                </div>
                                <span className="svg-icon"></span>
                                <div className="bottom-text">
                                    {data.map((item: any, index) => (
                                        <div className={`item-box item-box__${index}`} key={index}>
                                            <p className="item-num">{item.num}</p>
                                            <p className="item-text">{item.text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="scene-common night">
                        <div className="scene-text">
                            <div className="text-box">
                                <p className="scene-title">{t('sec2.night.title')}</p>
                                <p className="scene-desc">
                                    {t.rich('sec2.night.desc', {
                                        HighLight: (text: any) => <span className="green-text">{text}</span>,
                                        sup: (val: any) => <sup>{val}</sup>,
                                    })}
                                </p>
                            </div>
                            <div className="scene-video">
                                <div className="video-box">
                                    <EFVideo
                                        className="bg-video ani-04"
                                        autoPlay={true}
                                        loop={true}
                                        muted
                                        sources={[`${videoSrc}/4.webm`, `${videoSrc}/4.mp4`]}
                                    />
                                </div>
                                <span className="svg-icon"></span>
                            </div>
                        </div>
                    </div>
                    <div className="scene-common cuts">
                        <div className="scene-text">
                            <div className="text-box">
                                <p className="scene-title">{t('sec2.cuts.title')}</p>
                                <p className="scene-desc">
                                    {t.rich('sec2.cuts.desc', {
                                        HighLight: (text: any) => <span className="green-text">{text}</span>,
                                        sup: (val: any) => <sup>{val}</sup>,
                                    })}
                                </p>
                            </div>
                            <div className="scene-video">
                                <div className="video-box">
                                    <EFPic className="cuts-img" name={['5-0.webp', '5-0.jpg']} />
                                    <EFVideo
                                        className="bg-video ani-05"
                                        autoPlay={true}
                                        loop={true}
                                        muted
                                        sources={[`${videoSrc}/5.webm`, `${videoSrc}/5.mp4`]}
                                    />
                                </div>
                                <span className="svg-icon"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
